var render = function render(){var _vm=this,_c=_vm._self._c;return _c('McButton',{staticClass:"ms-2",attrs:{"variant":"secondary","size":"small","icon":"icon-outline_volume-up","text":"Tes Audio"},on:{"click":_vm.playAudio}})
}
var staticRenderFns = []

export { render, staticRenderFns }